import React, { Component } from 'react';
import axios from 'axios';
import { Input, Button, Modal, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import SimpleBar from 'simplebar-react';
import Swal from 'sweetalert2';
import i18next from 'i18next';

const { TextArea } = Input;

class ChatPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chatId: this.props.location.state ? this.props.location.state.chat_id : null, // Get chat_id from passed props
            messages_info: [],
            newMessage: '',
            is_disabled: false,
            is_location_ModalVisible: false,
            show_view_location_modal: false,
            position: { lat: 37.7749, lng: -122.4194 }, // Example position
            view_lat: null,
            view_lon: null,
            tasker_quoted_price: '',
            tasker_quoted_desc: '',
            tasker_quoted_price_err: '',
            tasker_quoted_desc_err: '',
        };
    }

    componentDidMount() {
        if (this.state.chatId) {
            this.fetchMessages(); // Fetch messages for this chat
        }
    }

    fetchMessages = async () => {
        const { chatId } = this.state;

        try {
            console.log('chatii',chatId);
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/chatmessages/${chatId}`);
            console.log('chatimes',response);
            this.setState({ messages_info: response.data.messages });
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    sendMessage = async () => {
        const { chatId, newMessage } = this.state;

        if (!newMessage) return;

        this.setState({ is_disabled: true });

        const user_info = JSON.parse(localStorage.getItem('user'));
        const params = new URLSearchParams();
        params.append('chat_id', chatId);
        params.append('user_id', user_info.user_id);
        params.append('message', newMessage);

        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/sendchatmessage`, params);

            if (response.data.status_code === 200) {
                this.setState({ newMessage: '', is_disabled: false });
                this.fetchMessages(); // Fetch messages after sending a new one
            } else {
                message.error('Failed to send message.');
                this.setState({ is_disabled: false });
            }
        } catch (error) {
            message.error('Error sending message.');
            this.setState({ is_disabled: false });
        }
    };

    handleLocationModal = () => {
        this.setState((prevState) => ({ is_location_ModalVisible: !prevState.is_location_ModalVisible }));
    };

    sendLocation = () => {
        const { position, chatId } = this.state;
        const user_info = JSON.parse(localStorage.getItem('user'));

        const params = new URLSearchParams();
        params.append('chat_id', chatId);
        params.append('user_id', user_info.user_id);
        params.append('lat', position.lat);
        params.append('lon', position.lng);

        axios.post(`${process.env.REACT_APP_BASE_URL}/web/api/v1/user/sendlocation`, params)
            .then(() => {
                this.handleLocationModal();
                message.success('Location sent successfully');
            })
            .catch((error) => {
                message.error('Error sending location');
            });
    };

    viewLocation = (lat, lon) => {
        this.setState({ show_view_location_modal: true, view_lat: lat, view_lon: lon });
    };

    location_modal_close = () => {
        this.setState({ is_location_ModalVisible: false });
    };

    view_location_modal_close = () => {
        this.setState({ show_view_location_modal: false });
    };

    handleInputChange = (event) => {
        this.setState({ newMessage: event.target.value });
    };

    render() {
        const { messages_info, newMessage, is_disabled, is_location_ModalVisible, show_view_location_modal, view_lat, view_lon } = this.state;

        return (
            <div className="chatPage">
                <section>
                    <div className="chatConversion">
                        <SimpleBar style={{ height: 'calc(100vh - 235px)', overflowX: 'hidden' }}>
                            <div className="d-flex flex-column py-3 px-4">
                                {messages_info && messages_info.length > 0 && messages_info.map((message, index) => (
                                    <div key={index} className={message.sender === 'user' ? 'receivedSection' : 'sentSection'}>
                                        <div className="parent">
                                            <span>{message.message}</span>
                                        </div>
                                        {message.timestamp && <div className="timeStamp">{message.timestamp}</div>}
                                        {message.type === 'location' && (
                                            <div className="locationContainer">
                                                <Button onClick={() => this.viewLocation(message.lat, message.lon)}>
                                                    {i18next.t('View Location')}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </SimpleBar>
                    </div>

                    {/* Typing Area */}
                    <div className="typingArea">
                        <div className="chatBoxInput">
                            <TextArea
                                value={newMessage}
                                onChange={this.handleInputChange}
                                placeholder={i18next.t('Type a message...')}
                                rows={3}
                            />
                            <div className="sendButton">
                                <Button
                                    type="primary"
                                    onClick={this.sendMessage}
                                    disabled={is_disabled}
                                >
                                    {is_disabled ? <LoadingOutlined /> : i18next.t('Send')}
                                </Button>
                            </div>
                        </div>

                        {/* Send Location Button */}
                        <div className="locationButton" onClick={this.handleLocationModal}>
                            <strong>{i18next.t('Send Location')}</strong>
                        </div>
                    </div>
                </section>

                {/* Location Modal */}
                <Modal
                    title="Location"
                    visible={is_location_ModalVisible}
                    onCancel={this.location_modal_close}
                    footer={[
                        <Button onClick={this.sendLocation}>{i18next.t('Send Location')}</Button>,
                        <Button onClick={this.location_modal_close}>{i18next.t('Close')}</Button>
                    ]}
                >
                    <div className="h-330">
                        {/* <Map
                            google={this.props.google && this.props.google}
                            center={this.state.position}
                            height="300px"
                            zoom={15}
                        /> */}
                    </div>
                </Modal>

                {/* View Location Modal */}
                <Modal
                    title="View Location"
                    visible={show_view_location_modal}
                    onCancel={this.view_location_modal_close}
                    footer={[<Button onClick={this.view_location_modal_close}>{i18next.t('Close')}</Button>]}
                >
                    {show_view_location_modal && (
                        <div className="h-330">
                            {/* <Map
                                google={this.props.google && this.props.google}
                                center={{ lat: parseFloat(view_lat), lng: parseFloat(view_lon) }}
                                height="300px"
                                zoom={15}
                            /> */}
                        </div>
                    )}
                </Modal>
            </div>
        );
    }
}

export default ChatPage;
